import './style.scss';
import Swiper, {
	Navigation,
	Pagination,
	A11y,
	Keyboard,
	Lazy,
	Thumbs,
} from 'swiper';

if (
	( 'complete' === document.readyState ||
		'loading' !== document.readyState ) &&
	! document.documentElement.doScroll
) {
	sliderBlockGutenberg();
} else {
	document.addEventListener( 'DOMContentLoaded', sliderBlockGutenberg );
}

/**
 * Start Slider function
 */
function sliderBlockGutenberg() {
	const gallery = document.querySelectorAll( '.gallery' );
	if ( gallery.length ) {
		gallery.forEach( ( slider ) => {
			const gallerySliderMultiple = slider.querySelectorAll( '.gallery-multiple' );
			const gallerySliderSingle = slider.querySelectorAll( '.gallery-single' );
      
			if ( gallerySliderMultiple.length && gallerySliderSingle.length ) {
				const galleryThumbs = new Swiper( '#'+gallerySliderMultiple[0].getAttribute('id'), {
					modules: [
						Navigation,
						Pagination, 
						A11y,
						Keyboard,
						Lazy,
						Thumbs,
					],
					spaceBetween: 10,
          slidesPerGroup: 1,
					touchRatio: 0.2,
					slideToClickedSlide: true,
					autoHeight: false,
					a11y: true,
					lazy: true,
					preloadImages: false,
					keyboard: true,
					breakpoints: {
						320: {
							slidesPerView: 3.7,
							spaceBetween: 8,
						},
						576: {
							slidesPerView: 6,
						},
						768: {
							slidesPerView: 5.2,
						},
						1024: {
							slidesPerView: 6.5,
						},
					},
				} );
        console.log(galleryThumbs);
        
				// eslint-disable-next-line no-unused-vars
				const _gallerySingle = new Swiper( '#'+gallerySliderSingle[0].getAttribute('id'), {
					spaceBetween: 0,
					slidesPerView: 1,
          slidesPerGroup: 1,
					modules: [
						Navigation,
						Pagination,
						A11y,
						Keyboard,
						Lazy,
						Thumbs,
					],

					navigation: {
						nextEl: '.gallery-button-next',
						prevEl: '.gallery-button-prev',
					},
					loop: false,
					a11y: true,
					lazy: true,
					preloadImages: false,
					keyboard: true,
					thumbs: {
						swiper: galleryThumbs,
						slideThumbActiveClass: 'swiper-slide-active',
					},
				} );
			}
		} );
	}
}
